import RegistrationForm from '../../../components/RegistrationForm/RegistrationForm'
import RichText from '../../../components/RichText/RichText'

export default function Register (props = {
    heading: null,
    richText: null,
    registrationForm: null
}) {
    return (
        <div className="register">
            <h1
                className="heading-2 margin-b"
            >
                {props.heading || 'Login'}
            </h1>
            <RichText
                html={props.richText}
            />
            <div className="margin-3-t">
                <RegistrationForm {...props.registrationForm} />
            </div>
        </div>
    )
}
